import { ShipmentsPageStyle } from 'shipments/ui/ShipmentsPageStyle'

import { type Shipment } from '../domain/Shipment'
import { getTimelineStates } from '../presenters/timelinePresenter'
import { ShipmentStop } from './ShipmentStop'

export type ShipmentTimelineProps = {
  shipment: Shipment
  refetchShipment: (uuid: string) => Promise<void>
}

export default function ShipmentTimeline({ shipment, refetchShipment }: ShipmentTimelineProps) {
  const stops = shipment?.stops ?? []
  const stopStates = getTimelineStates(stops)

  if (!stops.length) {
    return null
  }

  return (
    <>
      <ShipmentsPageStyle />
      <div className="ls-PageShipmentsTimeline" data-testid="shipment-timeline">
        {stops.map((stop, index) => (
          <div key={stop.id}>
            <ShipmentStop
              stop={stop}
              status={stop.stopType === 'delivery' ? 'Delivery' : 'Pickup'}
              stopState={stopStates[index]}
              lookupShipment={refetchShipment}
              shipment={shipment}
            />
          </div>
        ))}
      </div>
    </>
  )
}
